/**
 * 应用配置管理
 * 集中管理所有环境变量和应用配置
 */

// 从环境变量中获取基础配置
export const appConfig = {
  // 应用基本信息
  app: {
    domain: import.meta.env.VITE_WEB_DOMAIN,
    title: import.meta.env.VITE_APP_TITLE,
    version: import.meta.env.PACKAGE_VERSION,
  },

  // 环境配置
  env: {
    nodeEnv: import.meta.env.NODE_ENV || 'development',
    debug: import.meta.env.VITE_DEBUG === 'true',
    logLevel: import.meta.env.VITE_LOG_LEVEL || 'info',
  },

  // API配置
  api: {
    baseURL: import.meta.env.VITE_API_BASE_URL,
    timeout: 10000000,
    retry: {
      default: 0,
      important: 2,
      critical: 3,
    },
    retryDelay: 1000,
  },
  
  // 第三方API配置
  pApi: {
    baseURL: import.meta.env.VITE_API_BASE_URL_P,
    timeout: 10000000,
  },
  
  // 新架构API配置
  newApi: {
    baseURL: import.meta.env.VITE_API_BASE_URL_NEW,
    tokenBaseURL: import.meta.env.VITE_API_BASE_URL_NEW_TOKEN,
    timeout: 10000000,
  },

  // 缓存配置
  cache: {
    defaultExpire: 3600000, // 默认缓存时间（毫秒）
    maxSize: 100, // 最大缓存项数量
  },

  // 路由配置
  router: {
    beforeEachDelay: 0, // 全局前置守卫延迟时间
    scrollBehavior: {
      top: 0,
      behavior: 'smooth',
    },
  },

  // 其他配置
  features: {
    mockEnabled: import.meta.env.VITE_MOCK_ENABLED === 'true',
    analyticsEnabled: import.meta.env.VITE_ANALYTICS_ENABLED === 'true',
  },
};

// 导出配置获取函数
export const getConfig = () => appConfig;

export default appConfig;